// Precio en ARS para el catálogo: "$1.500" (sin decimales si es entero),
// "$1.500,50" si tiene centavos.
export const formatPrice = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';

    const decimals = Number.isInteger(amount) ? 0 : 2;
    return `$${amount.toLocaleString('es-AR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })}`;
};
